import React, {Fragment, useEffect, useState} from "react"
// import {bool, func, string} from "prop-types"
import {useHistory, useParams} from "react-router-dom"
import {NavLink} from "react-router-dom"
import FormValidate from "form-validate.js"
import Styled from "styled-components"
import moment from "moment-timezone"

// Spacing
import {spacing} from "@uprise/spacing"
// Colors
import {allianzColors, backgrounds, primary, semantic} from "@uprise/colors"
// Components
import {Card} from "@uprise/card"
import {H6} from "@uprise/headings"
import {ExtraSmall, Note} from "@uprise/text"
import {Button} from "@uprise/button"
import {Alert} from "@uprise/alert"
// Validation
import constraints from "validation/allianzSignup"
// Inputs
import {TextInput, Select} from "@uprise/form"
// Api
import {post, get} from "helpers/api"
// Utils
import {handleError} from "./utils"
// Country Codes
import CountryCodes from "utils/countryCodes"
import FullWidthDropdown from "../FullWidthDropdown"
import {InfoIcon, InfoImage, PolicyInputContainer, PolicyToolTipContainer, PolicyWrapper} from "./index.style"
import {text} from "@uprise/typography"

const PhoneInputWrapper = Styled.div`
	display : flex;
`

const TextInputWrapper = Styled(TextInput)`
	width: 100%;
	input[id="phone"]{
		margin-top:6px;
	}
`
const NameInputWrapper = Styled.div`
	display:flex;
	justify-content:space-between;
`
const PasswordMessage = Styled.div`
	font-size:${text.t3};
	margin-top:-15px;
	margin-bottom:${spacing.s4};
	color:${allianzColors.black2}
`
const PhoneNumberMessage = Styled.div`
	font-size:${text.t3};
	margin-top:-15px;
	margin-bottom:${spacing.s4};
	color:${allianzColors.black2}
`

const SmallNote = Styled(Note)`
	font-size:12px;
	margin-top:20px;
	margin-bottom:20px;
`
const userTypes = [
	{
		label: "Domestic Student",
		value: "domestic_student"
	},
	{
		label: "International Student",
		value: "international_student"
	},
	{
		label: "Staff",
		value: "staff"
	}
]

const GENDER_LIST = [
	{
		label: "Male",
		value: "male"
	},
	{
		label: "Female",
		value: "female"
	},
	{
		label: "GenderX",
		value: "genderx"
	}
]
const destinationCountryList = [
	// {label: "Australia", value: "AU", name: "+61"},
	{label: "New Zealand", value: "NZ", name: "+64"}
]
const SIGNUP_TYPE = [
	{label: "Policy Number", value: "policy_number"},
	{label: "Access Code", value: "access_code"}
]

const AllianzDeletion = ({children}) => {
	let history = useHistory()
	const {code = ""} = useParams()

	const [validation, setValidation] = useState({})
	const [validator, setValidator] = useState()
	const [firstName, setFirstName] = useState("")
	const [lastName, setLastName] = useState("")
	const [email, setEmail] = useState("")
	const [countryCode, setCountryCode] = useState(CountryCodes[132].label)
	const [countryName, setCountryName] = useState(CountryCodes[132].name)
	const [phone, setPhone] = useState("")
	const [password, setPassword] = useState("")
	const [accessCode, setAccessCode] = useState(code)
	const [error, setError] = useState({type: "", value: ""})
	const [isLoading, setIsLoading] = useState(false)
	const [submitted, setSubmitted] = useState(false)
	const [typeName, setTypeName] = useState()
	const [typeValue, setTypeValue] = useState()
	const [institutions, setInstitutions] = useState([])
	const [institutionName, setInstitutionName] = useState("")
	const [institutionValue, setInstitutionValue] = useState("")
	const [policyNumber, setPolicyNumber] = useState("")
	const [dob, setDOB] = useState()

	const [selectedDestinationCountry, setSelectedDestinationCountry] = useState(CountryCodes[132].label)
	const [selectedDestinationCountryName, setSelectedDestinationCountryName] = useState(CountryCodes[132].name)

	const [selectedNationality, setSelectedNationality] = useState()
	const [selectedNationalityName, setSelectedNationalityName] = useState()

	const [selectedGender, setSelectedGender] = useState()
	const [selectedGenderName, setSelectedGenderName] = useState()

	const [selectedSignupWith, setSelectedSignupWith] = useState("")

	const [studentId, setStudentId] = useState()

	const [customValidation, setCustomValidation] = useState({
		dob: "",
		institutionName: "",
		typeName: "",
		isOtherInvalid: "",
		destinationCountry: "",
		gender: "",
		nationality: "",
		signupWith: "",
		policyNumber: "",
		studentId: ""
	})

	const [showToolTip, setShowToolTip] = useState(false)

	useEffect(() => {
		const validator = new FormValidate(constraints, null, {
			accessCode: code
		})
		setValidator(validator)
		getInstitutions()
	}, [])

	const _validateForm = event => {
		validator.validate(event.nativeEvent, (valid, controls) => {
			console.log(valid, controls)
			if (submitted) {
				setValidation(controls)
			}
		})
	}

	const _handleSubmit = () => {
		setSubmitted(true)
		let error = {
			typeName: "",
			institutionName: "",
			dob: "",
			isOtherInvalid: false,
			destinationCountry: "",
			signupWith: "",
			policyNumber: "",
			studentId: ""
		}
		if (!validator.valid()) {
			// The same callback used in the validate function can be used here
			validator.touchAll((valid, controls) => {
				console.log(controls)
				setValidation(controls)
				error.isOtherInvalid = true
				// a good place to update the validation being displayed.
			})
		}
		if (!dob) {
			error["dob"] = "Please select valid dob"
		}
		if (!institutionName || institutionName.length <= 0) {
			error["institutionName"] = "Please select valid institution"
		}
		if (!typeName || typeName.length <= 0) {
			error["typeName"] = "Please select valid type"
		}
		if (!selectedDestinationCountry) {
			error["destinationCountry"] = "Please select valid destination country"
		}
		if (
			selectedDestinationCountry &&
			selectedDestinationCountry === "AU" &&
			(!policyNumber || policyNumber.toString().length < 2)
		) {
			error["policyNumber"] = "Please enter valid policy number"
		}
		if (
			selectedDestinationCountry &&
			selectedDestinationCountry === "NZ" &&
			(!studentId || studentId.toString().length < 2)
		) {
			error["studentId"] = "Please enter valid student id"
		}
		if (
			error.dob ||
			error.typeName ||
			error.institutionName ||
			error.isOtherInvalid ||
			error.destinationCountry ||
			error.signupWith ||
			error.policyNumber ||
			error.studentId
		) {
			setCustomValidation(error)
			return
		} else {
			_handleSignUp()
		}
	}

	const _handleSignUp = () => {
		setIsLoading(true)
		let data = {
			password,
			email: email.toLowerCase().trim(),
			firstName,
			lastName,
			phone: phone.trim(),
			countryCode,
			countryName,
			agreeTerms: true,
			institutionId: institutionValue,
			type: typeValue,
			policyNumber: policyNumber || "",
			dob: moment(dob).format("DD/MM/YYYY"),
			timezone: moment.tz.guess() || "Australia/Sydney",
			destinationCountry: selectedDestinationCountryName,
			studentId,
			gender: selectedGenderName,
			nationality: selectedNationalityName
		}
		console.log(data)
		post("signup-allianz", data)
			.then(response => {
				console.log(response)
				if (response?.code === "success") {
					history.push("/allianz-signup-confirmation", {
						email: email.toLowerCase().trim()
					})
				} else {
					setError(handleError(response?.error || "Error while signing up, please try again"))
				}
			})
			.catch(error => {
				console.error(error)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	const getInstitutions = async () => {
		const institutions = await get("get-institutions")
		if (institutions && institutions.data && institutions.data.length > 0) {
			let values = []
			institutions.data.map((el, index) => {
				values.push({
					label: el.institutionName,
					value: el.institutionName
				})
			})
			setInstitutions(values)
		}
	}

	return (
		<div style={{padding: 10}}>
			<Fragment>
				<H6 className='m-b-10' textAlign='center'>
					Request for your account deletion using the details provided on Your
					<br />
					Allianz Inbound Medical and Travel Insurance policy
				</H6>
				<Card
					className='m-b-4'
					backgroundColor={backgrounds.white}
					shadow={true}
					padding={spacing.s5}
					width='100%'>
					{error?.text?.length > 0 && (
						<Alert className='m-b-5' type={error.type}>
							{error.text}
						</Alert>
					)}

					<form onChange={event => _validateForm(event)}>
						<FullWidthDropdown
							validation={customValidation}
							id='institutionName'
							name='institutionName'
							isFullWidth={true}
							title={"University | Institution | Organisation*"}
							items={institutions}
							label=''
							onChange={value => {
								setInstitutionName(value.label)
								setInstitutionValue(value.value)
								if (value)
									setCustomValidation({
										...customValidation,
										institutionName: ""
									})
							}}
							customListItemRender={item => (
								<div style={{display: "flex", justifyContent: "space-between"}}>
									<p>{item.label}</p>
								</div>
							)}
						/>
						<FullWidthDropdown
							validation={customValidation}
							id='typeName'
							name='typeName'
							isFullWidth={true}
							title={"Status*"}
							items={userTypes}
							label=''
							onChange={value => {
								setTypeName(value.label)
								setTypeValue(value.value)
								if (value)
									setCustomValidation({
										...customValidation,
										typeName: ""
									})
							}}
							customListItemRender={item => (
								<div style={{display: "flex", justifyContent: "space-between"}}>
									<p>{item.label}</p>
								</div>
							)}
						/>
						{selectedDestinationCountry === "AU" && (
							<>
								<PolicyWrapper>
									<PolicyInputContainer>
										<TextInput
											onChange={e => {
												setPolicyNumber(e.target.value)
												if (e.target.value) {
													setCustomValidation({
														...customValidation,
														policyNumber: ""
													})
												}
											}}
											validation={customValidation}
											value={policyNumber}
											id='policyNumber'
											name='policyNumber'
											label='Policy Number'
											isRequired
											isLast
										/>
									</PolicyInputContainer>
									<PolicyToolTipContainer>
										<InfoIcon onClick={() => setShowToolTip(true)}>
											<InfoImage src={require("assets/images/allianz/info-icon.png")} />
										</InfoIcon>
									</PolicyToolTipContainer>
								</PolicyWrapper>
								<div style={{marginBottom: 21, color: semantic.error, fontSize: 12, marginTop: 10}}>
									{customValidation?.policyNumber || ""}
								</div>
							</>
						)}

						<>
							<TextInput
								onChange={e => {
									setStudentId(e.target.value)
									if (e.target.value) {
										setCustomValidation({
											...customValidation,
											studentId: ""
										})
									}
								}}
								style={{
									marginBottom: 10
								}}
								value={studentId}
								id='studentId'
								name='studentId'
								label={`Student Id${selectedDestinationCountry === "AU" ? "(Optional)" : "*"}`}
								validation={customValidation}
							/>
							<div style={{marginBottom: 21, color: semantic.error, fontSize: 12}}>
								{customValidation?.studentId || ""}
							</div>
						</>
						<TextInput
							onChange={e => setEmail(e.target.value)}
							validation={validation}
							value={email}
							id='email'
							name='email'
							label='Email Address'
							isRequired
						/>
					</form>
				</Card>
				<ExtraSmall className='m-b-4'>
					By continuing, you agree to the{" "}
					<a
						href={`https://uprise.co/terms`}
						target='__blank'
						rel='noopener noreferrer'
						style={{color: primary.purple, fontWeight: "bold"}}>
						Terms
					</a>{" "}
					{", "}
					<a
						href={`https://uprise.co/privacy`}
						target='__blank'
						rel='noopener noreferrer'
						style={{color: primary.purple, fontWeight: "bold"}}>
						Privacy Policy
					</a>{" "}
					and{" "}
					<a
						href='https://www.legislation.govt.nz/regulation/public/1996/0343/latest/DLM225616.html'
						target='_blank'
						rel='noreferrer'
						style={{color: primary.purple, fontWeight: "bold"}}>
						Health Data Retention Policy
					</a>
					.
				</ExtraSmall>
				<Button
					data-testid='sign-up-button'
					variant='primary'
					className='m-b-4'
					title='Request Deletion'
					size='large'
					fullWidth={true}
					isLoading={isLoading}
					disabled={false}
					onClick={() => _handleSubmit()}
				/>
				<SmallNote>
					<b>Note:</b> The storage and maintenance of Health Related data by Uprise Services Pty Ltd on behalf
					of Allianz NZ and the Allianz Mental Wellbeing App is subject to New Zealand law, including the{" "}
					<a
						href='https://www.legislation.govt.nz/regulation/public/1996/0343/latest/DLM225616.html'
						target='_blank'
						rel='noreferrer'
						style={{color: primary.purple, fontWeight: "bold"}}>
						Health (Retention of Health Information) Regulations 1996
					</a>
					. It is also protected through the{" "}
					<a
						href='https://uprise.co/privacy'
						target='_blank'
						rel='noreferrer'
						style={{color: primary.purple, fontWeight: "bold"}}>
						Uprise Privacy policy
					</a>
				</SmallNote>
			</Fragment>
		</div>
	)
}

// array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

export default AllianzDeletion
